import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getAuthData, hydrateSessionFromAuthData } from '../utils/authStorage';

const parseRoles = (value) => {
  if (Array.isArray(value)) {
    return value;
  }

  if (!value) {
    return [];
  }

  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.warn('Unable to parse roles from storage', error);
    return [];
  }
};

const useAuth = () => {
  const location = useLocation();
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    roles: [],
    isLoading: true,
  });

  useEffect(() => {
    const evaluateAuthentication = () => {
      let token = sessionStorage.getItem('token');
      let roles = parseRoles(sessionStorage.getItem('roles'));

      if (!token) {
        const cachedAuth = getAuthData();
        if (cachedAuth && cachedAuth.token) {
          hydrateSessionFromAuthData(cachedAuth);
          token = cachedAuth.token;
          roles = parseRoles(cachedAuth.roles);
        }
      }

      if (token) {
        if (!roles || roles.length === 0) {
          roles = parseRoles(sessionStorage.getItem('roles'));
        }

        setAuthState({
          isAuthenticated: true,
          roles,
          isLoading: false,
        });
      } else {
        setAuthState({
          isAuthenticated: false,
          roles: [],
          isLoading: false,
        });
      }
    };

    evaluateAuthentication();
  }, [location.pathname]);

  return authState;
};

export default useAuth;
